import React from 'react';

const FrameworkBackground = () => (
    <svg
        width="2258" height="2258" viewBox="0 0 2258 2258" fill="none" xmlns="http://www.w3.org/2000/svg"
        style={{
            position: 'absolute',
            right: '-15%',
            top: '70%',
            transform: 'translateY(-50%)',
            height: 450,
            width: 'auto',
            opacity: 0.15,
            pointerEvents: 'none',
        }}
    >
        <path d="M1006 1924.48V1292.65H380.82V1163.65H145.5C145.5 1164.65 145.5 1165.54 145.5 1166.54C145.5 1707.17 580.204 2145.67 1117.57 2148.65V1924.58H1006V1924.48Z" fill="#D1D5DB"/>
        <path d="M380.746 1040.46H1005.99V378.367H1117.57V145.85C583.616 148.951 151.144 598.892 145.5 1155.84H380.746V1040.46Z" fill="#D1D5DB"/>
        <path d="M1251.87 376.09V1034.54H1873.37V1154.84H2112.77C2110.07 597.254 1670.17 145.981 1127.57 144.85V376.09H1251.97H1251.87Z" fill="#D1D5DB"/>
        <path d="M1873.39 1288.05H1251.96V1923.35H1127.57V2148.65C1671.01 2147.55 2111.47 1707.25 2112.77 1163.65H1873.39V1287.95V1288.05Z" fill="#D1D5DB"/>
        <circle cx="1129" cy="1129" r="1127" stroke="#9CA3AF" strokeWidth="4"/>
    </svg>
);

const OhsPdfPage = ({children, Footer, showBackground}) => {
    return (
        <section className={'Page ohs-page'}>
            <div className='Page__content' style={{ position: 'relative', overflow: 'hidden' }}>
                {showBackground && <FrameworkBackground />}
                <div className='Page__callout' style={{ position: 'relative', zIndex: 1 }}>{children}</div>
            </div>
            {Footer}
        </section>
    );
};

export default OhsPdfPage;
